import { ProgramSettings, ProgramSettingsFormValues } from '@/types/setting';

const DEFAULT_CURRENCY_VALUE = '0.00';

export function mapProgramSettingsToFormValues(
  programSettings: ProgramSettings | undefined,
): ProgramSettingsFormValues {
  if (!programSettings) {
    return createDefaultFormValues();
  }

  const {
    minimumInitDeposit,
    maximumInitDeposit,
    feeIncomingDomestic,
    feeOutcomeDomestic,
    feeMonthlySavingAccount,
    achCreditProgramLimitPerRollingDay,
    achDebitProgramLimitPerRollingDay,
    achCreditAccountLimitPerCalendarDay,
    achDebitAccountLimitPerCalendarDay,
    achCreditLimitPerTransaction,
    achDebitLimitPerTransaction,
    wireOutProgramLimitPerRollingDay,
    wireOutAccountLimitPerCalendarDay,
    wireOutLimitPerTransaction,
    wireRequestReviewThreshold,
    checkDepositProgramLimitPerRollingDay,
    checkDepositAccountLimitPerCalendarDay,
    checkDepositAccountLimitPerCalendarMonth,
    checkDepositLimitPerTransaction,
    checkIssuanceProgramLimitPerRollingDay,
    checkIssuanceAccountLimitPerCalendarDay,
    checkIssuanceAccountLimitPerCalendarMonth,
    checkIssuanceLimitPerTransaction,
    rateSavingInterest,
    rateSavingInterestUpdatedAt,
    indexFactSheetLink,
  } = programSettings;

  return {
    minimumInitDeposit: getMoneyValue(minimumInitDeposit),
    maximumInitDeposit: getMoneyValue(maximumInitDeposit),
    feeIncomingDomestic: getMoneyValue(feeIncomingDomestic),
    feeOutcomeDomestic: getMoneyValue(feeOutcomeDomestic),
    feeMonthlySavingAccount: getMoneyValue(feeMonthlySavingAccount),
    achCreditProgramLimitPerRollingDay: getMoneyValue(
      achCreditProgramLimitPerRollingDay,
    ),
    achDebitProgramLimitPerRollingDay: getMoneyValue(
      achDebitProgramLimitPerRollingDay,
    ),
    achCreditAccountLimitPerCalendarDay: getMoneyValue(
      achCreditAccountLimitPerCalendarDay,
    ),
    achDebitAccountLimitPerCalendarDay: getMoneyValue(
      achDebitAccountLimitPerCalendarDay,
    ),
    achCreditLimitPerTransaction: getMoneyValue(achCreditLimitPerTransaction),
    achDebitLimitPerTransaction: getMoneyValue(achDebitLimitPerTransaction),
    wireOutProgramLimitPerRollingDay: getMoneyValue(
      wireOutProgramLimitPerRollingDay,
    ),
    wireOutAccountLimitPerCalendarDay: getMoneyValue(
      wireOutAccountLimitPerCalendarDay,
    ),
    wireOutLimitPerTransaction: getMoneyValue(wireOutLimitPerTransaction),
    wireRequestReviewThreshold: getMoneyValue(wireRequestReviewThreshold),
    checkDepositLimitPerTransaction: getMoneyValue(
      checkDepositLimitPerTransaction,
    ),
    checkDepositAccountLimitPerCalendarDay: getMoneyValue(
      checkDepositAccountLimitPerCalendarDay,
    ),
    checkDepositAccountLimitPerCalendarMonth: getMoneyValue(
      checkDepositAccountLimitPerCalendarMonth,
    ),
    checkDepositProgramLimitPerRollingDay: getMoneyValue(
      checkDepositProgramLimitPerRollingDay,
    ),
    checkIssuanceLimitPerTransaction: getMoneyValue(
      checkIssuanceLimitPerTransaction,
    ),
    checkIssuanceAccountLimitPerCalendarDay: getMoneyValue(
      checkIssuanceAccountLimitPerCalendarDay,
    ),
    checkIssuanceAccountLimitPerCalendarMonth: getMoneyValue(
      checkIssuanceAccountLimitPerCalendarMonth,
    ),
    checkIssuanceProgramLimitPerRollingDay: getMoneyValue(
      checkIssuanceProgramLimitPerRollingDay,
    ),
    rateSavingInterest: rateSavingInterest || '',
    rateSavingInterestUpdatedAt: rateSavingInterestUpdatedAt || '',
    indexFactSheetLink: indexFactSheetLink || '',
  };
}

function getMoneyValue(money?: { value: number | string }): string {
  return money ? `${money.value}` : DEFAULT_CURRENCY_VALUE;
}

function createDefaultFormValues(): ProgramSettingsFormValues {
  return {
    minimumInitDeposit: DEFAULT_CURRENCY_VALUE,
    maximumInitDeposit: DEFAULT_CURRENCY_VALUE,
    feeIncomingDomestic: DEFAULT_CURRENCY_VALUE,
    feeOutcomeDomestic: DEFAULT_CURRENCY_VALUE,
    feeMonthlySavingAccount: DEFAULT_CURRENCY_VALUE,
    achCreditProgramLimitPerRollingDay: DEFAULT_CURRENCY_VALUE,
    achDebitProgramLimitPerRollingDay: DEFAULT_CURRENCY_VALUE,
    achCreditAccountLimitPerCalendarDay: DEFAULT_CURRENCY_VALUE,
    achDebitAccountLimitPerCalendarDay: DEFAULT_CURRENCY_VALUE,
    achCreditLimitPerTransaction: DEFAULT_CURRENCY_VALUE,
    achDebitLimitPerTransaction: DEFAULT_CURRENCY_VALUE,
    wireOutProgramLimitPerRollingDay: DEFAULT_CURRENCY_VALUE,
    wireOutAccountLimitPerCalendarDay: DEFAULT_CURRENCY_VALUE,
    wireOutLimitPerTransaction: DEFAULT_CURRENCY_VALUE,
    wireRequestReviewThreshold: DEFAULT_CURRENCY_VALUE,
    checkDepositLimitPerTransaction: DEFAULT_CURRENCY_VALUE,
    checkDepositAccountLimitPerCalendarDay: DEFAULT_CURRENCY_VALUE,
    checkDepositAccountLimitPerCalendarMonth: DEFAULT_CURRENCY_VALUE,
    checkDepositProgramLimitPerRollingDay: DEFAULT_CURRENCY_VALUE,
    checkIssuanceLimitPerTransaction: DEFAULT_CURRENCY_VALUE,
    checkIssuanceAccountLimitPerCalendarDay: DEFAULT_CURRENCY_VALUE,
    checkIssuanceAccountLimitPerCalendarMonth: DEFAULT_CURRENCY_VALUE,
    checkIssuanceProgramLimitPerRollingDay: DEFAULT_CURRENCY_VALUE,
    rateSavingInterest: '',
    rateSavingInterestUpdatedAt: '',
    indexFactSheetLink: '',
  };
}
